import { BrowserRouter, Routes, Route } from "react-router-dom";

import { GtmRouteListener } from "./analytics/GtmRouteListener";
import { AuthLayout } from "./layouts/AuthLayout";
import { RegistrationRoutesLayout } from "./layouts/RegistrationRoutesLayout";
import { CallbackPage } from "./pages/CallbackPage";
import { ForgotEmailPage } from "./pages/ForgotEmailPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { SuccessPage } from "./pages/SuccessPage";
import {
  RegValuePropPage,
  RegisterFlow,
  RegisterSuccessPage,
  RegisterFeedbackPage,
  RegisterFeedbackCommentPage,
  RegisterFeedbackThankYouPage,
  DownloadAppPage,
} from "@fmc-digital/profile";

export function AppRoutes() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <GtmRouteListener />
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/" element={<LoginPage />}  />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/forgot-email" element={<ForgotEmailPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route element={<RegistrationRoutesLayout />}>
            <Route path="/register" element={<RegValuePropPage />} />
            <Route path="/register/create-account" element={<RegisterFlow />} />
            <Route path="/register/success" element={<RegisterSuccessPage />} />
            <Route path="/register/feedback" element={<RegisterFeedbackPage />} />
            <Route path="/register/feedback/comment" element={<RegisterFeedbackCommentPage />} />
            <Route path="/register/feedback/thank-you" element={<RegisterFeedbackThankYouPage />} />
            <Route path="/register/download-app" element={<DownloadAppPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
